__turbopack_context__.v({
  "games": "collection-module__Of2XEa__games",
  "main": "collection-module__Of2XEa__main",
});
